import IconPdf from "@/assets/teacher-class/pdf.png";
import IconAudio from "@/assets/teacher-class/sound.png";
import IconVideo from "@/assets/teacher-class/video.png";
import { ExposureItemMedia } from "@/store/lesson/state";
import { Empty, Tooltip } from "ant-design-vue";
import { PropType, computed, defineComponent, inject } from "vue";
import { useStore } from "vuex";
import { fmtMsg } from "vue-glcommonui";
import { TeacherClassLessonPlan } from "@/locales/localeid";
import { FilmIcon, SpeakerWaveIcon, DocumentIcon } from "@heroicons/vue/24/outline";
import { MediaType } from "@/models";
import { ExposureDetailType } from "@/views/teacher-class/components/lesson-plan/lesson-plan";
import { MODULES, vuexName } from "@/store/utils";

export default defineComponent({
  props: {
    items: {
      type: Object as PropType<ExposureItemMedia[][]>,
      required: true,
    },
  },
  components: {
    Tooltip,
    Empty,
    FilmIcon,
    SpeakerWaveIcon,
    DocumentIcon,
  },
  setup(props) {
    const store = useStore();
    const isHelper = computed<boolean>(() => store.getters[vuexName(MODULES.TEACHER.GETTERS.GET_IS_HELPER)]);
    const NoDataText = computed(() => fmtMsg(TeacherClassLessonPlan.NoData));
    const currentExposureItemMedia = computed<ExposureItemMedia | undefined>(
      () => store.getters[vuexName(MODULES.LESSON.GETTERS.GET_CURRENT_EXPOSURE_ITEM_MEDIA)],
    );
    const handleLessonItemChange: ((id: string, exposureType?: ExposureDetailType) => void) | undefined = inject("lesson-item-change");
    const onClickItem = (id: string) => {
      if (isHelper.value) return;
      if (id === currentExposureItemMedia.value?.id) return;
      handleLessonItemChange?.(id, ExposureDetailType.ALTERNATE_MEDIA_BLOCK);
    };
    const isEmpty = computed(() => !props.items.length);
    const slides = computed(() => props.items.flat(1));
    return {
      onClickItem,
      currentExposureItemMedia,
      isEmpty,
      IconAudio,
      IconVideo,
      IconPdf,
      slides,
      NoDataText,
      isHelper,
      MediaType,
    };
  },
});
